<template>
  <v-dialog
    v-model="dialog"
    :max-width="500"
    scrollable
    persistent
    :retain-focus="false"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card v-if="todo" class="p-todo-view-dialog" outlined>
      <v-card-title>
        {{ todoMapped.title }}
        <v-spacer></v-spacer>
        <p-btn-icon type="edit" @click="edit"></p-btn-icon>
        <p-btn-icon type="delete" @click="delete_"></p-btn-icon>
        <p-btn-icon type="close" @click="closeDialog" btn-class="mr-n3"></p-btn-icon>
      </v-card-title>

      <v-card-text>
        <div class="p-todo-view-dialog__description">{{ todoMapped.description }}</div>
        <div class="p-todo-view-dialog__project p-dark-gray--text">{{ todoMapped.project.title }}</div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text v-if="todoHasDetails">
        <h3 class="p-dark-gray--text">{{$t('todo.details')}}</h3>
        <div v-if="todoMapped.deadlineFormatted" class="p-todo-view-dialog__section-row">
          <v-icon>mdi-calendar-blank-outline</v-icon>
          <span>{{ todoMapped.deadlineFormatted }}</span>
        </div>
        <div v-if="todoMapped.users.length > 0" class="p-todo-view-dialog__section-row">
          <v-icon class="mt-5 align-self-baseline">mdi-account-multiple-outline</v-icon>
          <div>
            <p-user-item
              v-for="user in todoMapped.users"
              :key="user.id"
              :value="user"
              avatar-class="mr-2"
            ></p-user-item>
          </div>
        </div>
        <div v-if="todoMapped.attachments.length" class="p-todo-view-dialog__section-row">
          <v-col>
            <div class="p-todo-view-dialog__attachments">
              <div>
                <v-icon class="mdi-rotate-270">mdi-attachment</v-icon>
              </div>
              <div>
                <div v-for="attachment in todoMapped.attachments" :key="`attachment-${attachment.id}`">
                  <p-file-icon :extension="attachment.extension"></p-file-icon>
                  <span class="p-link" @click.stop="downloadFile(attachment)">{{attachment.name}}</span>
                </div>
              </div>
            </div>
          </v-col>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapGetters } from 'vuex'

import moment from 'moment'

import PUserItem from '@/components/PUserItem'
import PBtnIcon from '@/components/PBtnIcon'
import PFileIcon from '@/components/PFileIcon'

import dialogMixin from '@/mixins/dialog.mixin'


export default {
  components: {
    PUserItem,
    PBtnIcon,
    PFileIcon
  },


  mixins: [
    dialogMixin
  ],


  props: {
    todo: Object
  },


  computed: {
    ...mapGetters('project', ['shortProjectById']),

    todoHasDetails () {
      return this.todoMapped.deadlineFormatted || this.todoMapped.users?.length || this.todoMapped.attachments?.length
    },

    todoMapped () {
      if (!this.todo) {
        return {}
      }

      const deadlineFormatted = this.todo.deadline ? moment.utc(this.todo.deadline).format('ll') : null
      const project = this.shortProjectById(this.todo.projectId) || {}

      return {
        ...this.todo,
        project,
        deadlineFormatted
      }
    }
  },


  methods: {
    edit () {
      this.$emit('edit', this.todo)
      this.closeDialog()
    },

    delete_ () {
      this.$emit('delete', this.todo)
      this.closeDialog()
    }
  }
}
</script>
